import * as React from 'react'
import { ListItem, ListItemText } from '@mui/material'
import { Typography as MIUTypography } from '@mui/material'
import { styled } from '@mui/material/styles'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '0.8em',
  fontWeight: props.istitle ? 600 : 500,
  lineHeight: 1,
  color: props.islabel ? '#6A6A6A' : '#1B1C37',
  textAlign: props.islabel ? 'start' : 'center',
}))

const ListItemRow = ({ label, value, width = '50%', icon, styleTextValue }) => (
  <ListItem
    component="div"
    disablePadding
    sx={{
      minHeight: 24,
      justifyContent: 'initial',
      py: 0,
    }}>
    <ListItemText sx={{ marginTop: '2px' }}>
      <div
        style={{
          display: 'flex',
          flexFlow: 'row nowrap',
        }}>
        {label && (
          <Typography
            component="div"
            islabel={1}
            sx={{
              flexGrow: 1,
              textAlign: 'start',
              width,
              fontSize: 13,
            }}>
            {label}:
          </Typography>
        )}
        <Typography
          component="div"
          sx={{
            flexGrow: 10,
            fontSize: 14,
            fontStyle: label === 'Nombre científico' ? 'italic' : 'none',
            ...styleTextValue,
          }}>
          {label === 'Nombre científico' ? `${value?.[0]}` : `${value}`}
          <span
            style={{
              fontStyle: 'normal',
              display: label === 'Nombre científico' ? 'inline' : 'none',
            }}>
            {' '}
            {value?.[1]}
          </span>
          {icon}
        </Typography>
      </div>
    </ListItemText>
  </ListItem>
)

export default ListItemRow
